import { windowFactory } from 'src/shared/factories/window.factory';

export enum Platform {
  ANDROID = 'android',
  IOS = 'ios',
  WEB = 'web',
}

export enum Brand {
  GRUBHUB = 'GRUBHUB',
  SEAMLESS = 'SEAMLESS',
}

export enum Environment {
  DEVELOPMENT = 'development',
  PREPROD = 'preproduction',
  PROD = 'production',
  RC = 'rc',
}

export const enum SubscriptionPurchasePaths {
  INFO_NATIVE = '/modules/subscriptions/info',
  INFO = '/plus',
  INFO_SLUG = '/plus/:slug',
  CONFIRMATION = '/plus/confirmation',
  PURCHASE = '/plus/purchase',
  PURCHASE_CLICKSTREAM = '/plus/purchase?sendClickstreamCtaEvent=true',
  EDIT = '/plus/edit',
  CANCEL = '/modules/subscriptions/cancel',
  CANCEL_PLUS = '/plus/manage/cancel',
  MANAGEMENT = '/modules/subscriptions',
  MANAGEMENT_ACTIONS = '/modules/subscriptions/actions',
  MANAGEMENT_WEB = '/account/subscription',
  MANAGEMENT_PLUS = '/plus/manage',
  INELGIBLE = '/plus/ineligible',
  MIGRATION_PARTNER = '/partner/:slug/migration',
  MIGRATION_PARTNER_SUCCESS = '/partner/:slug/migration/success',
  CANCEL_CONFIRMATION = '/plus/canceled',
  PARTNER_ERROR = '/partner/giveaway-error',
  PARTNER_GIVEAWAY_ELIGIBILITY = '/partner/:slug/eligibility',
  PARTNER_PAGE = '/partner/:slug',
  PARTNER_SUBPAGE = '/partner/:slug/:subpage',
  CANCELLATION_PERK = '/modules/subscriptions/cancellation-perk',
  CANCELLATION_SURVEY = '/modules/subscriptions/cancellation-survey',
  CANCELLATION_QUESTION = '/modules/subscriptions/cancellation-question',
}

export const enum DinerConnectionsPaths {
  ENTRY = '/partner/:slug/diner-connections/entry',
  CONNECT = '/partner/:slug/diner-connections/connect/:paramsString*',
}

const defaultConfiguration = {} as AppConfig;

export const APP_CONFIG: AppConfig =
  windowFactory().ghsConfiguration || defaultConfiguration;
